import { ResourceProvider } from '../resourceProvider';
import { AppConfig } from '../appConfig';
import { getContentPath } from '../utils/api';

export function translateCountries(countries: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel[]): SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel[] {
	//translate codelist and add image
	for (var i = 0; i < countries.length; i++) {
		let countryTranslationKey = AppConfig.AvailableListConstants.CountryTranslationKeyPrefix + countries[i].Code + AppConfig.AvailableListConstants.CountryTranslationKeyPostfix;
		countries[i].Value = ResourceProvider.getText(countryTranslationKey, AppConfig.TranslationNamespaces.CodeList);
		countries[i].ImageUrl = getContentPath() + 'img/flags/' + `${countries[i].Code.toLowerCase()}.svg`;
	}

	//sort by value
	countries = countries.sort((a: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel, b: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel) =>
		a.Value.localeCompare(b.Value));

	return countries;
}